import axios from 'axios';
import { toast } from 'react-toastify';
import { config } from './utils';
import {
  BundleBulkImportResponse,
  BundleBulkImportType,
} from './bundleProductBulkImport';

const ensureBearerToken = (token: string) => {
  if (!token) return '';
  return token.startsWith('Bearer ') ? token : `Bearer ${token}`;
};

export const importBundleProductsFromExcel = async (
  excelFile: File,
  imageFiles: File[],
  token: string,
  importType: BundleBulkImportType = 'bundle',
  activeState = false
): Promise<BundleBulkImportResponse | null> => {
  const formData = new FormData();
  formData.append('excel', excelFile);
  imageFiles.forEach((file) => {
    formData.append('images', file);
  });

  const activeStateQuery = activeState ? 'true' : 'false';

  try {
    const response = await axios.post<BundleBulkImportResponse>(
      `${config.BASE_URL}/bundle-product-bulk-import?importType=${importType}&activeState=${activeStateQuery}`,
      formData,
      {
        headers: {
          Authorization: ensureBearerToken(token),
        },
        timeout: 10 * 60 * 1000,
      }
    );

    return response.data;
  } catch (error: any) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Product bulk import failed';

    toast.error(typeof message === 'string' ? message : 'Product bulk import failed');
    console.error('importBundleProductsFromExcel error', error);
    return null;
  }
};
